






































import { Component, Vue } from 'vue-property-decorator';
import { institutionServer, yunnanDataViewServer } from '@/api/installServer';
import * as echarts from 'echarts';

@Component({
  components: {},
})
export default class DataBox3 extends Vue {
  private $echarts: any;
  private dataForm: any = {
    block2: {},
    block3: {},
  };
  searchForm: any = {};

  hazardTotal: any = {};
  maxTotal: any = 0;

  mounted() {
    // this.getData({});
  }

  getData(opts: any) {
    this.hazardTotal = {
      安全管理类: 0,
      从业人员类: 0,
      从业场所类: 0,
      设施设备类: 0,
    };
    const totalArr: any = [];
    yunnanDataViewServer
      .getHazard({ deptId: opts.deptId || null })
      .then((res: any) => {
        this.dataForm = res.data;
        this.dataForm.block2.forEach((item: any) => {
          totalArr.push(item.hazardTotal);
        });
        this.maxTotal = Math.max(...totalArr);
        this.maxTotal === 0 && (this.maxTotal = 1);
        this.showCharts();
      })
      .catch((e: any) => {
        console.log(e);
      });
  }

  private showCharts() {
    const echartsA = this.$echarts.init(document.getElementById('house-charts-7-1') as any);

    const color = ['#0091FF', '#13BCFF', '#FF6262', '#FC8452', '#91CC75'];
    const colorList = [
      new echarts.graphic.LinearGradient(0, 0, 1, 1, [
        {
          offset: 0,
          color: 'rgba(0,145,255,0.9)',
        },
        {
          offset: 1,
          color: 'rgba(0,145,255,0.9)',
        },
      ]),
      new echarts.graphic.LinearGradient(0, 0, 1, 1, [
        {
          offset: 0,
          color: '#13BCFF',
        },
        {
          offset: 1,
          color: '#13BCFF',
        },
      ]),
      new echarts.graphic.LinearGradient(0, 0, 1, 1, [
        {
          offset: 0,
          color: '#FF6262',
        },
        {
          offset: 1,
          color: '#FF6262',
        },
      ]),
      new echarts.graphic.LinearGradient(0, 0, 1, 1, [
        {
          offset: 0,
          color: '#FC8452',
        },
        {
          offset: 1,
          color: '#FC8452',
        },
      ]),
      new echarts.graphic.LinearGradient(0, 0, 1, 1, [
        {
          offset: 0,
          color: '#91CC75',
        },
        {
          offset: 1,
          color: '#91CC75',
        },
      ]),
    ];

    const chartData: any = [];
    const arrNum: any = [0, 0, 0, 0, 0];

    this.dataForm.block3.forEach((item: any) => {
      switch (item.sourceTypeLabel) {
        case '隐患排查':
        case '巡检隐患排查':
          arrNum[0] += item.hazardTotal;
          // chartData.push({
          //   name: '隐患排查',
          //   value: item.hazardTotal,
          //   unit: '个',
          // });
          break;
        case '隐患上报':
        case '隐患上报(扫码)':
          arrNum[1] += item.hazardTotal;
          // chartData.push({
          //   name: '隐患上报',
          //   value: item.hazardTotal,
          //   unit: '个',
          // });
          break;
        case '安全检查':
          arrNum[2] += item.hazardTotal;
          // chartData.push({
          //   name: '安全检查',
          //   value: item.hazardTotal,
          //   unit: '个',
          // });
          break;
        case '随手查-风险':
        case '随手查-环境':
        case '随手查-环境(扫码)':
        case '随手查-风险(扫码)':
          arrNum[3] += item.hazardTotal;
          // chartData.push({
          //   name: '风险随查',
          //   value: item.hazardTotal,
          //   unit: '个',
          // });
          break;
        case '随手拍':
        case '随手拍(扫码)':
          arrNum[4] += item.hazardTotal;
          // chartData.push({
          //   name: ' 随 手 拍',
          //   value: item.hazardTotal,
          //   unit: '个',
          // });
          break;
      }
    });
    const typeNameArr: any = ['隐患排查', '隐患上报', '安全检查', '风险随查', '随  手 拍'];

    typeNameArr.forEach((item: any, index: any) => {
      chartData.push({
        name: item,
        value: arrNum[index],
        unit: '个',
      });
    });

    chartData.sort((x: any, y: any) => {
      if (x.value < y.value) {
        return 1;
      }
      if (x.value > y.value) {
        return -1;
      }
      return 0;
    });

    const arrName = [];
    const arrValue = [];
    let sum = 0;
    const pieSeries: any = [],
      lineYAxis: any = [];

    // 数据处理
    chartData.forEach((v: any, i: any) => {
      arrName.push(v.name);
      arrValue.push(v.value);
      // sum = sum + v.value;
      v.value > sum && (sum = v.value);
    });
    sum = sum * 1.25;

    // 图表option整理
    chartData.forEach((v: any, i: any) => {
      pieSeries.push({
        name: '',
        type: 'pie',
        clockWise: false,
        hoverAnimation: false,
        radius: [80 - i * 15 + '%', 70 - i * 15 + '%'],
        center: ['50%', '48%'],
        label: {
          show: false,
        },
        data: [
          {
            value: v.value * 4,
            name: v.name,
            itemStyle: {
              // shadowColor: colorop[i],
              shadowColor: 'rgba(255,255,255,0)',
              shadowBlur: 24,
              shadowOffsetX: '5',
              shadowOffsetY: '5',
            },
          },
          {
            value: sum,
            name: '',
            itemStyle: {
              // color: 'rgba(0,0,0,0)',
              color: 'rgba(0,0,0,0)',
            },
          },
        ],
      });
      pieSeries.push({
        name: '',
        type: 'pie',
        silent: true,
        z: 1,
        clockWise: false, //顺时加载
        hoverAnimation: false, //鼠标移入变大
        radius: [80 - i * 15 + '%', 70 - i * 15 + '%'],
        center: ['50%', '48%'],
        label: {
          show: false,
        },
        data: [
          {
            value: 7.5,
            itemStyle: {
              color: 'rgba(255,255,255,0)',
            },
          },
          {
            value: 2.5,
            name: '',
            itemStyle: {
              color: 'rgba(0,0,0,0)',
            },
          },
        ],
      });
      v.percent = v.value;
      lineYAxis.push({
        value: i,
        textStyle: {
          rich: {
            circle: {
              color: color[i],
              padding: [0, 5],
              fontSize: 12,
              fontWeight: 600,
            },
          },
        },
      });
    });

    const optionA = {
      // backgroundColor: '#ffffffff',
      // color: colorList,
      color: colorList,
      grid: {
        top: '7%',
        bottom: '55%',
        left: '48%',
        containLabel: false,
      },
      yAxis: [
        {
          type: 'category',
          inverse: true,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            formatter: function(params: any) {
              const item: any = chartData[params];
              console.log(item);
              return '{line|}{circle|●}{name|' + item.name + '}{bd|}{circle|' + item.percent + '}';
            },
            interval: 0,
            inside: true,
            textStyle: {
              color: '#e6f7ff',
              fontSize: 12,
              rich: {
                name: {
                  color: '#9FACBB',
                  fontSize: 12,
                },
                bd: {
                  color: '#e6f7ff',
                  padding: [0, 5],
                  fontSize: 12,
                },
                percent: {
                  color: '#333',
                  fontSize: 12,
                },
                value: {
                  color: '#333',
                  fontSize: 12,
                  fontWeight: 500,
                  padding: [0, 0, 0, 20],
                },
                unit: {
                  fontSize: 12,
                },
              },
            },
            show: true,
          },
          data: lineYAxis,
        },
      ],
      xAxis: [
        {
          show: false,
        },
      ],
      series: pieSeries,
    };

    echartsA.setOption(optionA);
  }
}
